import { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

import StoreStateModel from "../../Utils/Models/store";

import { signOutUser } from "../../../store/actions";

const Profile = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const auth = useSelector((state: StoreStateModel) => state.auth, shallowEqual);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container>
      <IconButton
        sx={{ color: theme.palette.text.primary }}
        color={!anchorEl ? "inherit" : "primary"}
        onClick={handleClick}
      >
        <PersonIcon />
      </IconButton>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{ sx: { bgcolor: theme.palette.background.paper } }}
        MenuListProps={{
          "aria-labelledby": "profile-button",
          style: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.secondary,
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <Box p={2} display="flex" flexDirection="column" alignItems="center">
          <Typography sx={{ fontWeight: 500 }} variant="subtitle1">
            {auth.userName}
          </Typography>
          <Typography sx={{ color: (theme) => theme.palette.grey[500], pb: 2 }}>
            {auth.email}
          </Typography>
          <Typography>{auth.accountName}</Typography>
        </Box>
        <Divider />
        <Box width={1} display="flex" justifyContent="center" pt={2} pb={1}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => dispatch(signOutUser())}
            sx={{
              borderColor: theme.palette.primary.main,
            }}
          >
            Logout
          </Button>
        </Box>
      </Menu>
    </Grid>
  );
};
export default Profile;
